import React from 'react';

import styles from '../styles';

function SuccessStep() {
  const classes = styles();

  return (
    <div className={classes.successMsg}>
      <img width={64} height={63} src='/img/success_icon.svg' alt='Ícone verde de sucesso' />
      <span>Sua solicitação de transferência foi recebida com sucesso e será realizada em até 24 horas.</span>
    </div>
  );
}

export default SuccessStep;
